import {TemplateDataFields} from '@/Agent/ContactForm/EmailEditor/EmailEditor';
import API from '@/APIs/API';
import {ParameterStore} from '@/Core/mobx/ParameterStore/ParameterStore';

export const adbAPI = async (parameterStore: ParameterStore) => {
    const {quote, prequal} = parameterStore;

    const applicantAge = prequal.age.value;
    const applicantGender = prequal.gender.value;
    const rop = quote.returnOnPremiumADB.value;
    const coverage = quote.specifiedCoverageADB.value;
    const planType = quote.planTypeADB.value;
    const includeChildren = quote.includeChildrenADB.value;
    const secondCoveredAdultAge = quote.secondCoveredAdultAgeADB.value;

    const retrievalParams = new URLSearchParams({
        applicantAge: String(applicantAge),
        applicantGender: applicantGender,
        rop: String(rop),
        coverage: String(coverage),
        includeChildren: String(includeChildren),
    });

    if (planType !== '_1Adult') {
        retrievalParams.set('secondCoveredAdultAge', String(secondCoveredAdultAge));
    }

    try {
        const data = await API.Call<{quotes: any[]; cursor: string}>(
            `v2/internal/quotes/adb?${retrievalParams.toString()}`,
            'GET',
            undefined,
        );

        if (!data || !data.quotes || data.quotes.length === 0) {
            return null;
        }

        const adbQuote = data.quotes[0];
        console.log('ADB quote data:', adbQuote);

        const {premium} = adbQuote;

        return {
            faceAmount: coverage,
            monthlyPremium: premium,
            productName: quote.productADB.valueAsString(),
            out: [
                {
                    name: 'Carrier',
                    value: 'Mutual of Omaha',
                    type: 'string',
                    fieldName: TemplateDataFields.carrier,
                },
                {
                    name: 'Product',
                    value: 'ADB',
                    type: 'string',
                    fieldName: 'product',
                },
                {
                    name: 'Product name',
                    value: quote.productADB.valueAsString(),
                    type: 'string',
                    fieldName: TemplateDataFields.productName,
                },
                {
                    name: 'Gender',
                    value: applicantGender,
                    type: 'string',
                    fieldName: 'gender',
                },
                {
                    name: 'Monthly premium',
                    value: premium,
                    type: 'currency',
                    fieldName: TemplateDataFields.monthlyPremium,
                },
                {
                    name: 'Annual premium',
                    value: premium * 12,
                    type: 'currency',
                    fieldName: 'annualPremium',
                },
                {
                    name: 'Death benefit',
                    value: coverage,
                    type: 'currency',
                    fieldName: TemplateDataFields.faceAmount,
                },
                {
                    name: 'Valid',
                    value: 'valid',
                    type: 'string',
                },
            ],
            requestDetails: {
                applicantAge,
                applicantGender,
                rop,
                coverage,
                planType,
                includeChildren,
                secondCoveredAdultAge,
            },
        };
    } catch (error) {
        console.error('Failed to load ADB quote. Please try again.');
        return null;
    }
};
